<template>
  <header class="header">
    <div class="header__inner">
      <div class="header__logo">摸鲸科技</div>
      <nav class="header__nav">
        <a href="#products" class="header__link" @click.prevent="scrollTo('products')">产品</a>
        <a href="#technology" class="header__link" @click.prevent="scrollTo('technology')">技术</a>
        <a href="#partnership" class="header__link" @click.prevent="scrollTo('partnership')">合作</a>
      </nav>
    </div>
    <div class="header__gradient-line"></div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    scrollTo(id) {
      var el = document.getElementById(id)
      if (el) {
        var headerHeight = document.querySelector('.header').offsetHeight
        var elementPosition = el.getBoundingClientRect().top + window.pageYOffset
        var offsetPosition = elementPosition - headerHeight
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #0A0A0F;
}

.header__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 60px;
}

.header__logo {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #FFFFFF;
}

.header__nav {
  display: flex;
}

.header__link {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #9CA3AF;
  transition: color 0.2s;
  margin-left: 48px;
}

.header__link:first-child {
  margin-left: 0;
}

.header__link:hover {
  color: #FFFFFF;
}

.header__gradient-line {
  height: 1px;
  background: -webkit-linear-gradient(left,
    rgba(10, 10, 15, 0) 0%,
    rgba(59, 130, 246, 0.5) 35%,
    rgba(139, 92, 246, 0.5) 65%,
    rgba(10, 10, 15, 0) 100%
  );
  background: linear-gradient(
    90deg,
    rgba(10, 10, 15, 0) 0%,
    rgba(59, 130, 246, 0.5) 35%,
    rgba(139, 92, 246, 0.5) 65%,
    rgba(10, 10, 15, 0) 100%
  );
}

@media (max-width: 1024px) {
  .header__inner {
    padding: 0 30px;
  }
  .header__link {
    font-size: 14px;
    margin-left: 24px;
  }
  .header__logo {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .header__inner {
    padding: 0 20px;
  }
  .header__logo {
    font-size: 18px;
  }
  .header__nav {
    display: flex;
    gap: 16px;
  }
  .header__link {
    font-size: 13px;
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .header__inner {
    padding: 0 16px;
  }
  .header__logo {
    font-size: 16px;
  }
  .header__link {
    font-size: 12px;
    gap: 12px;
  }
}
</style>
